
	const 	tabbed_contents = [...document.querySelectorAll('.js-tabbed-content')],
			classes = {
				active_class: 'active',
			};

	tabbed_contents.forEach( function ( tabbed_content ) {
		tabbed_content.classList.remove('nojs');

		const 	tabbed_content_triggers = [...tabbed_content.querySelectorAll('.js-tabbed-content-trigger')],
				tabbed_content_elements = [...tabbed_content.querySelectorAll('.js-tabbed-content-element')];

		let current_index = 0;

		tabbed_content_triggers.forEach( function ( tabbed_content_trigger ) {
			tabbed_content_trigger.addEventListener( 'click', function ( event ) {
				const clicked_index = tabbed_content_triggers.indexOf( tabbed_content_trigger );

				if ( current_index != clicked_index ) handle_tab_change( clicked_index );
			} );

			function handle_tab_change ( new_index ) {
				activate_new_element( new_index, tabbed_content_triggers );
				activate_new_element( new_index, tabbed_content_elements );

				current_index = new_index;
			}

			function activate_new_element ( new_index, target_elements ) {
				target_elements[ current_index ].classList.remove( classes.active_class );

				target_elements[ new_index ].classList.add( classes.active_class );
			}
		} );

		tabbed_content_triggers[ current_index ].classList.add( classes.active_class );
		tabbed_content_elements[ current_index ].classList.add( classes.active_class );
		
	} );